// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  padding: 208px 0 110px;
  background: radial-gradient(120% 120% at 15% -10%, var(--ink-700) 0%, var(--ink-800) 55%, var(--ink-900) 100%);
  overflow: hidden;
}

.hero__blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.45;
  z-index: 0;
}

.hero__blob--teal {
  width: 480px;
  height: 480px;
  background: var(--teal);
  top: -160px;
  right: -120px;
}

.hero__blob--amber {
  width: 420px;
  height: 420px;
  background: var(--amber);
  bottom: -180px;
  left: -140px;
  opacity: 0.3;
}

.hero__inner {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 56px;
  align-items: center;
}

.hero__title {
  margin-top: 20px;
  font-size: clamp(34px, 5vw, 56px);
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.5px;
}

.hero__title-accent {
  background: linear-gradient(120deg, var(--teal), var(--amber));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hero__desc {
  margin-top: 22px;
  max-width: 560px;
  font-size: 16.5px;
  color: rgba(255, 255, 255, 0.72);
}

.hero__desc strong {
  color: #fff;
}

.hero__actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 34px;
}

.hero__stats {
  display: flex;
  gap: 34px;
  margin-top: 50px;
  flex-wrap: wrap;
}

.hero__stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hero__stat strong {
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 800;
  background: linear-gradient(120deg, var(--teal), var(--amber));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hero__stat span {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 600;
}

.hero__visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero__ring {
  width: min(420px, 90%);
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  padding: 10px;
  background: linear-gradient(135deg, rgba(0, 198, 167, 0.5), rgba(245, 158, 11, 0.5));
  animation: float 6s ease-in-out infinite;
}

.hero__ring img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
}

.hero__floating {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--glass-light-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-light-border);
  color: var(--text-dark);
  font-size: 12.5px;
  font-weight: 700;
  font-family: var(--font-display);
  padding: 12px 16px;
  border-radius: 100px;
  box-shadow: var(--shadow-md);
}

.hero__floating--top {
  top: 6%;
  left: -4%;
}

.hero__floating--bottom {
  bottom: 8%;
  right: -6%;
}

.hero__floating-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--teal);
  box-shadow: 0 0 0 4px rgba(0, 198, 167, 0.25);
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-14px);
  }
}

@media (max-width: 980px) {
  .hero {
    padding: 180px 0 80px;
  }
  .hero__inner {
    grid-template-columns: 1fr;
  }
  .hero__visual {
    margin-top: 30px;
  }
  .hero__floating--top,
  .hero__floating--bottom {
    left: 0;
    right: 0;
  }
}

@media (max-width: 520px) {
  .hero__floating {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8GAA8G;EAC9G,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,8DAA8D;EAC9D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,oFAAoF;EACpF,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,wCAAwC;EACxC,gDAAgD;EAChD,2CAA2C;EAC3C,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,OAAO;IACP,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".hero {\n  position: relative;\n  padding: 208px 0 110px;\n  background: radial-gradient(120% 120% at 15% -10%, var(--ink-700) 0%, var(--ink-800) 55%, var(--ink-900) 100%);\n  overflow: hidden;\n}\n\n.hero__blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  opacity: 0.45;\n  z-index: 0;\n}\n\n.hero__blob--teal {\n  width: 480px;\n  height: 480px;\n  background: var(--teal);\n  top: -160px;\n  right: -120px;\n}\n\n.hero__blob--amber {\n  width: 420px;\n  height: 420px;\n  background: var(--amber);\n  bottom: -180px;\n  left: -140px;\n  opacity: 0.3;\n}\n\n.hero__inner {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 56px;\n  align-items: center;\n}\n\n.hero__title {\n  margin-top: 20px;\n  font-size: clamp(34px, 5vw, 56px);\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: -0.5px;\n}\n\n.hero__title-accent {\n  background: linear-gradient(120deg, var(--teal), var(--amber));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.hero__desc {\n  margin-top: 22px;\n  max-width: 560px;\n  font-size: 16.5px;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.hero__desc strong {\n  color: #fff;\n}\n\n.hero__actions {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 34px;\n}\n\n.hero__stats {\n  display: flex;\n  gap: 34px;\n  margin-top: 50px;\n  flex-wrap: wrap;\n}\n\n.hero__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.hero__stat strong {\n  font-family: var(--font-display);\n  font-size: 26px;\n  font-weight: 800;\n  background: linear-gradient(120deg, var(--teal), var(--amber));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.hero__stat span {\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.55);\n  font-weight: 600;\n}\n\n.hero__visual {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero__ring {\n  width: min(420px, 90%);\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  padding: 10px;\n  background: linear-gradient(135deg, rgba(0, 198, 167, 0.5), rgba(245, 158, 11, 0.5));\n  animation: float 6s ease-in-out infinite;\n}\n\n.hero__ring img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #fff;\n}\n\n.hero__floating {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--glass-light-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border: 1px solid var(--glass-light-border);\n  color: var(--text-dark);\n  font-size: 12.5px;\n  font-weight: 700;\n  font-family: var(--font-display);\n  padding: 12px 16px;\n  border-radius: 100px;\n  box-shadow: var(--shadow-md);\n}\n\n.hero__floating--top {\n  top: 6%;\n  left: -4%;\n}\n\n.hero__floating--bottom {\n  bottom: 8%;\n  right: -6%;\n}\n\n.hero__floating-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--teal);\n  box-shadow: 0 0 0 4px rgba(0, 198, 167, 0.25);\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-14px);\n  }\n}\n\n@media (max-width: 980px) {\n  .hero {\n    padding: 180px 0 80px;\n  }\n  .hero__inner {\n    grid-template-columns: 1fr;\n  }\n  .hero__visual {\n    margin-top: 30px;\n  }\n  .hero__floating--top,\n  .hero__floating--bottom {\n    left: 0;\n    right: 0;\n  }\n}\n\n@media (max-width: 520px) {\n  .hero__floating {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
